export var IconPosition;

!function(IconPosition) {
    IconPosition.inlineFront = "inlineFront", IconPosition.inlineEnd = "inlineEnd", 
    IconPosition.left = "left", IconPosition.right = "right", IconPosition.absoluteRight = "absoluteRight", 
    IconPosition.contentLeft = "contentLeft", IconPosition.contentRight = "contentRight", 
    IconPosition.absolute = "absolute";
}(IconPosition || (IconPosition = {}));

export var IconFuncTypeEnum;

!function(IconFuncTypeEnum) {
    IconFuncTypeEnum.frozen = "frozen", IconFuncTypeEnum.sort = "sort", IconFuncTypeEnum.dropDown = "dropDown", 
    IconFuncTypeEnum.dropDownState = "dropDownState", IconFuncTypeEnum.play = "play", 
    IconFuncTypeEnum.damagePic = "damagePic", IconFuncTypeEnum.imageDamagePic = "imageDamagePic", 
    IconFuncTypeEnum.videoDamagePic = "videoDamagePic", IconFuncTypeEnum.expand = "expand", 
    IconFuncTypeEnum.collapse = "collapse", IconFuncTypeEnum.drillDown = "drillDown", 
    IconFuncTypeEnum.drillUp = "drillUp", IconFuncTypeEnum.dragReorder = "dragReorder";
}(IconFuncTypeEnum || (IconFuncTypeEnum = {}));

export var InternalIconName;

!function(InternalIconName) {
    InternalIconName.upwardIconName = "sort_upward", InternalIconName.downwardIconName = "sort_downward", 
    InternalIconName.normalIconName = "sort_normal", InternalIconName.freezeIconName = "freeze", 
    InternalIconName.frozenIconName = "frozen", InternalIconName.frozenCurrentIconName = "frozenCurrent", 
    InternalIconName.dropdownIconName = "dropdownIcon", InternalIconName.expandIconName = "expand", 
    InternalIconName.collapseIconName = "collapse", InternalIconName.dragReorderIconName = "dragReorder", 
    InternalIconName.loadingIconName = "loading";
}(InternalIconName || (InternalIconName = {}));
//# sourceMappingURL=icon.js.map
